import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-3 md:gap-4" }
const _hoisted_2 = { class: "col-span-12 xxl:col-span-12 grid grid-cols-12 gap-6" }
const _hoisted_3 = { class: "col-span-12 mt-4" }
const _hoisted_4 = { class: "intro-y flex flex-row items-center h-auto sm:h-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-medium truncate" }, "Data Affiliate", -1)
const _hoisted_6 = { class: "ml-auto mt-2 sm:mt-0 flex flex-row items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Tambah", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Reload Data", -1)
const _hoisted_9 = { class: "intro-y col-span-12" }
const _hoisted_10 = { class: "intro-y col-span-12 box pt-3 px-3 pb-5" }
const _hoisted_11 = { class: "grid grid-cols-3 gap-2 mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col md:flex-row items-center col-span-3 md:col-span-1" }, null, -1)
const _hoisted_13 = { class: "w-full col-span-3 md:col-span-2" }
const _hoisted_14 = { class: "w-full md:w-56 relative text-gray-700 dark:text-gray-300 md:ml-auto" }
const _hoisted_15 = { class: "overflow-x-auto scrollbar-nav-soal" }
const _hoisted_16 = { class: "table" }
const _hoisted_17 = { class: "border-b dark:border-dark-5 whitespace-nowrap" }
const _hoisted_18 = { class: "border-b dark:border-dark-5 whitespace-nowrap" }
const _hoisted_19 = { class: "border-b dark:border-dark-5 whitespace-nowrap" }
const _hoisted_20 = { class: "border-b dark:border-dark-5 whitespace-nowrap" }
const _hoisted_21 = { class: "border-b dark:border-dark-5 whitespace-nowrap" }
const _hoisted_22 = { class: "border-b dark:border-dark-5 whitespace-nowrap" }
const _hoisted_23 = { class: "border-b dark:border-dark-5 whitespace-nowrap w-20" }
const _hoisted_24 = { class: "flex flex-row" }
const _hoisted_25 = {
  key: 0,
  class: "w-full p-5 flex items-center justify-center"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold" }, "Tidak Ada Data Affiliate.", -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 0,
  class: "intro-y flex flex-wrap sm:flex-row sm:flex-nowrap items-center mt-6"
}
const _hoisted_29 = { class: "pagination" }
const _hoisted_30 = { class: "pagination__link" }
const _hoisted_31 = { class: "pagination__link" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "pagination__link" }
const _hoisted_34 = { class: "pagination__link" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", null, "5", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", null, "10", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", null, "25", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", null, "35", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", null, "50", -1)
const _hoisted_40 = [
  _hoisted_35,
  _hoisted_36,
  _hoisted_37,
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = {
  id: "modal-data-oa",
  class: "modal p-0"
}
const _hoisted_42 = { class: "modal__content modal__content--lg" }
const _hoisted_43 = { class: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5" }
const _hoisted_44 = { class: "font-medium text-base mr-auto" }
const _hoisted_45 = { class: "px-3 md:px-5 py-3" }
const _hoisted_46 = { class: "flex flex-col sm:flex-row items-center" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Nama", -1)
const _hoisted_48 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Email", -1)
const _hoisted_50 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Phone Number", -1)
const _hoisted_52 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Username", -1)
const _hoisted_54 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Password", -1)
const _hoisted_56 = { class: "relative w-full sm:w-5/6" }
const _hoisted_57 = {
  key: 0,
  class: "flex flex-col sm:flex-row items-center mt-3"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "w-full whitespace-nowrap sm:w-20 sm:text-right sm:mr-5" }, "Status", -1)
const _hoisted_59 = { class: "w-1/2" }
const _hoisted_60 = ["value"]
const _hoisted_61 = { class: "px-5 py-3 text-center border-t border-gray-200 dark:border-dark-5" }
const _hoisted_62 = {
  id: "modal-detail-oa",
  class: "modal p-0"
}
const _hoisted_63 = { class: "modal__content modal__content--lg" }
const _hoisted_64 = { class: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-base mr-auto" }, "Detail Affiliate", -1)
const _hoisted_66 = { class: "px-3 md:px-5 pt-3 pb-5" }
const _hoisted_67 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Nama", -1)
const _hoisted_69 = { class: "text-gray-500" }
const _hoisted_70 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Email", -1)
const _hoisted_72 = { class: "text-gray-500" }
const _hoisted_73 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Phone", -1)
const _hoisted_75 = { class: "text-gray-500" }
const _hoisted_76 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Username", -1)
const _hoisted_78 = { class: "text-gray-500" }
const _hoisted_79 = { class: "flex flex-col sm:flex-row items-center mt-3" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { class: "w-full sm:w-20 sm:text-right sm:mr-5" }, "Photo", -1)
const _hoisted_81 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_RefreshCcwIcon = _resolveComponent("RefreshCcwIcon")!
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_FileIcon = _resolveComponent("FileIcon")!
  const _component_Tippy = _resolveComponent("Tippy")!
  const _component_Edit3Icon = _resolveComponent("Edit3Icon")!
  const _component_LoadingDiv = _resolveComponent("LoadingDiv")!
  const _component_ChevronsLeftIcon = _resolveComponent("ChevronsLeftIcon")!
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_ChevronsRightIcon = _resolveComponent("ChevronsRightIcon")!
  const _component_xIcon = _resolveComponent("xIcon")!
  const _component_TailSelect = _resolveComponent("TailSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "button bg-theme-1 hover:bg-primary text-white flex items-center w-auto mr-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addOA()))
            }, [
              _createVNode(_component_PlusIcon, { class: "w-4 h-4 mr-0 md:mr-2" }),
              _hoisted_7
            ]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getData())),
              class: "button bg-theme-1 hover:bg-primary text-white flex"
            }, [
              _createVNode(_component_RefreshCcwIcon, { class: "w-4 h-4 mr-0 md:mr-2" }),
              _hoisted_8
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "input w-full box pr-10 border border-gray-400 dark:bg-dark-4",
                placeholder: "Search...",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataOA.search) = $event)),
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.getData()), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.dataOA.search]
              ]),
              _createVNode(_component_SearchIcon, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getData())),
                class: "w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0 cursor-pointer"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("table", _hoisted_16, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titleTable, (k, idx) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: idx,
                    class: "border-b-2 dark:border-dark-5 whitespace-nowrap"
                  }, _toDisplayString(k), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataOA.data, (u, idx) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: idx,
                  class: _normalizeClass([idx % 2 === 0 ? 'bg-gray-200 dark:bg-dark-1' : ''])
                }, [
                  _createElementVNode("td", _hoisted_17, _toDisplayString(u.name), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(u.username), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(u.email), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(u.phone), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(u.active === 1 ? "Active" : " Suspend"), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.$h.formatDate(u.createdAt, "DD MMM, YYYY HH:mm:ss")), 1),
                  _createElementVNode("td", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_Tippy, {
                        tag: "a",
                        href: "javascript:;",
                        class: "inline-block mr-2",
                        content: "Detail",
                        onClick: ($event: any) => (_ctx.detailOAApi(u))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_FileIcon, { class: "w-6 h-6 cursor-pointer text-primary" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_Tippy, {
                        tag: "a",
                        href: "javascript:;",
                        class: "inline-block mr-2",
                        content: "Edit",
                        onClick: ($event: any) => (_ctx.editOA(u))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Edit3Icon, { class: "w-6 h-6 cursor-pointer text-theme-12" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          (_ctx.dataOA.data.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
            : _createCommentVNode("", true),
          _createVNode(_component_LoadingDiv, { id: "loadingOA" })
        ])
      ]),
      (_ctx.dataOA.data.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("ul", _hoisted_29, [
              (_ctx.dataOA.page !== 1)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToPage(1)))
                  }, [
                    _createElementVNode("span", _hoisted_30, [
                      _createVNode(_component_ChevronsLeftIcon, { class: "w-4 h-4" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.dataOA.page !== 1)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 1,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.beforePage()))
                  }, [
                    _createElementVNode("span", _hoisted_31, [
                      _createVNode(_component_ChevronLeftIcon, { class: "w-4 h-4" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataOA.paginate.pages, (p, idx) => {
                return (_openBlock(), _createElementBlock("li", { key: idx }, [
                  _createElementVNode("span", {
                    class: _normalizeClass([
                'pagination__link cursor-pointer',
                _ctx.dataOA.page === p ? 'pagination__link--active' : '',
              ]),
                    onClick: ($event: any) => (_ctx.goToPage(p))
                  }, _toDisplayString(p), 11, _hoisted_32)
                ]))
              }), 128)),
              (_ctx.dataOA.page !== _ctx.dataOA.paginate.totalPages)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 2,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.nextPage()))
                  }, [
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_ChevronRightIcon, { class: "w-4 h-4" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.dataOA.page !== _ctx.dataOA.paginate.totalPages)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 3,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.lastPage()))
                  }, [
                    _createElementVNode("span", _hoisted_34, [
                      _createVNode(_component_ChevronsRightIcon, { class: "w-4 h-4" })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "w-20 input box mt-3 sm:mt-0",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dataOA.pageSize) = $event)),
              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePS()))
            }, _hoisted_40, 544), [
              [_vModelSelect, _ctx.dataOA.pageSize]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("h2", _hoisted_44, _toDisplayString(_ctx.section === "add" ? "Tambah Affiliate" : "Edit Affiliate"), 1),
          _createElementVNode("a", {
            href: "javascript:;",
            class: "right-0 top-0",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$gpf.hideModal('#modal-data-oa')))
          }, [
            _createVNode(_component_xIcon, { class: "w-6 h-6 text-gray-500" })
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "Nama",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.exDataOA.nama) = $event))
            }, null, 512), [
              [_vModelText, _ctx.exDataOA.nama]
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: "input w-full border flex-1",
              placeholder: "Email",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.exDataOA.email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.exDataOA.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "Phone Number",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.exDataOA.phone) = $event))
            }, null, 512), [
              [_vModelText, _ctx.exDataOA.phone]
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "input w-full border flex-1",
              placeholder: "username",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.exDataOA.username) = $event))
            }, null, 512), [
              [_vModelText, _ctx.exDataOA.username]
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("div", _hoisted_56, [
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: "input pr-12 w-full border col-span-10",
                placeholder: "Password",
                id: "passExDataOA",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.exDataOA.password) = $event))
              }, null, 512), [
                [_vModelText, _ctx.exDataOA.password]
              ]),
              _createElementVNode("div", {
                class: "absolute top-0 right-0 rounded-r w-14 h-full flex items-center justify-center bg-gray-100 dark:bg-dark-1 dark:border-dark-4 border text-gray-600 cursor-pointer",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$gpf.showPass('passExDataOA')))
              }, " show ")
            ])
          ]),
          (_ctx.section === 'edit')
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _createVNode(_component_TailSelect, {
                    modelValue: _ctx.exDataOA.status,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.exDataOA.status) = $event)),
                    onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.changeTS($event, 'status'))),
                    options: {
                  classNames: 'w-full',
                }
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (s, idx) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: idx,
                          value: s.value
                        }, _toDisplayString(s.title), 9, _hoisted_60))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("button", {
            type: "button",
            class: "button w-20 bg-theme-6 text-white mr-2",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$gpf.hideModal('#modal-data-oa')))
          }, " Close "),
          (_ctx.section === 'add')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "button w-20 bg-theme-1 text-white",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.addOAApi()))
              }, " Simpan "))
            : _createCommentVNode("", true),
          (_ctx.section === 'edit')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "button w-20 bg-theme-1 text-white",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.editOAApi()))
              }, " Update "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _hoisted_65,
          _createElementVNode("a", {
            href: "javascript:;",
            class: "right-0 top-0",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$gpf.hideModal('#modal-detail-oa')))
          }, [
            _createVNode(_component_xIcon, { class: "w-6 h-6 text-gray-500" })
          ])
        ]),
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _hoisted_68,
            _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.detailDataOA.nama), 1)
          ]),
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("p", _hoisted_72, _toDisplayString(_ctx.detailDataOA.email), 1)
          ]),
          _createElementVNode("div", _hoisted_73, [
            _hoisted_74,
            _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.detailDataOA.phone), 1)
          ]),
          _createElementVNode("div", _hoisted_76, [
            _hoisted_77,
            _createElementVNode("p", _hoisted_78, _toDisplayString(_ctx.detailDataOA.username), 1)
          ]),
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("img", {
              src: _ctx.detailDataOA.photo,
              alt: "",
              class: "w-40 max-h-full"
            }, null, 8, _hoisted_81)
          ])
        ])
      ])
    ])
  ]))
}